import React from 'react';
import { HasClassName } from '../component-utils';
import { useSelector } from '../hook-utils';
import { DeviceGroupType, Presence } from '../model';
import { selectExtendedAvailablePresenceEnabled } from '../store/reducers/config';
import { ReactComponent as AvailableAssoicate } from './icons/presence/presence-available-associate.svg';
import { ReactComponent as AvailableHome } from './icons/presence/presence-available-home.svg';
import { ReactComponent as AvailableMobile } from './icons/presence/presence-available-mobile.svg';
import { ReactComponent as AvailableOther } from './icons/presence/presence-available-other.svg';
import { ReactComponent as Available } from './icons/presence/presence-available.svg';
import { ReactComponent as AvailableAway } from './icons/presence/presence-available-away.svg';
import { ReactComponent as Away } from './icons/presence/presence-away.svg';
import { ReactComponent as Break } from './icons/presence/presence-break.svg';
import { ReactComponent as BusinessTrip } from './icons/presence/presence-business_trip.svg';
import { ReactComponent as DoNotDisturb } from './icons/presence/presence-dnd.svg';
import { ReactComponent as Gone } from './icons/presence/presence-gone.svg';
import { ReactComponent as Holiday } from './icons/presence/presence-leave.svg';
import { ReactComponent as Meeting } from './icons/presence/presence-meeting.svg';
import { ReactComponent as Queue } from './icons/presence/presence-queue.svg';
import { ReactComponent as QueueAway } from './icons/presence/presence-queue-away.svg';
import { ReactComponent as SickLeave } from './icons/presence/presence-sick.svg';
import { ReactComponent as Unknown } from './icons/presence/presence-unknown.svg';
import { ReactComponent as WorkTime } from './icons/presence/presence-work_time.svg';

interface Props extends HasClassName {
  presence: Presence
  deviceGroupType?: DeviceGroupType
  awayFromDesk?: boolean
}

export default function PresenceIcon({ className, presence, deviceGroupType, awayFromDesk }: Props) {
  const show = useSelector(selectExtendedAvailablePresenceEnabled)
  return React.cloneElement(getIcon(presence, deviceGroupType || DeviceGroupType.None, show, awayFromDesk), { className });
}

function getIcon(presence: Presence, deviceGroupType: DeviceGroupType | undefined, extendedAvailablePresence: boolean, awayFromDesk?: boolean) {
  switch (presence) {
    case Presence.WorkTime:
      return <WorkTime />;
    case Presence.Queue:
      if (awayFromDesk) {
        return <QueueAway />
      }
      return <Queue />;
    case Presence.Available:
      if (awayFromDesk) {
        return <AvailableAway />
      }

      if (extendedAvailablePresence) {
        switch (deviceGroupType) {
          case DeviceGroupType.Associate:
            return <AvailableAssoicate />;
          case DeviceGroupType.Home:
            return <AvailableHome />;
          case DeviceGroupType.Mobile:
            return <AvailableMobile />;
          case DeviceGroupType.Other:
            return <AvailableOther />;
          default:
            return <Available />;
        }
      } else {
        return <Available />;
      }
    case Presence.Meeting:
      return <Meeting />;
    case Presence.DoNotDisturb:
      return <DoNotDisturb />;
    case Presence.Away:
      return <Away />;
    case Presence.Gone:
      return <Gone />;
    case Presence.Holiday:
      return <Holiday />;
    case Presence.SickLeave:
      return <SickLeave />;
    case Presence.Break:
      return <Break />;
    case Presence.BusinessTrip:
      return <BusinessTrip />;
    default:
      return <Unknown />;
  }
}
